import { STATUS_LABEL, TIPO_LABEL } from "./financeiro-obras-filtros.constants";
import type {
  FinanceiroObrasFiltrosProps,
  FinanceiroObrasFiltrosViewModel,
} from "./types-financeiro-obras-filtros";

/** Filtros rápidos de Status e Tipo do topo (desktop): seleção múltipla; lista vazia = sem filtro. */
export function useFinanceiroObrasFiltros({
  statusValue,
  statusOptions,
  onStatusChange,
  tipoValue,
  tipoOptions,
  isTipoDisabled,
  onTipoChange,
}: FinanceiroObrasFiltrosProps): FinanceiroObrasFiltrosViewModel {
  return {
    status: {
      placeholder: STATUS_LABEL,
      "aria-label": STATUS_LABEL,
      "data-testid": "financeiro-obras-status-filter",
      value: statusValue,
      options: statusOptions,
      disabled: false,
      onChange: onStatusChange,
    },
    tipo: {
      placeholder: TIPO_LABEL,
      "aria-label": TIPO_LABEL,
      "data-testid": "financeiro-obras-tipo-filter",
      value: tipoValue,
      options: tipoOptions,
      disabled: isTipoDisabled,
      onChange: onTipoChange,
    },
  };
}
